/**
 * Coalesce concurrent identical async requests into a single in-flight promise.
 */

const inflight = new Map<string, Promise<unknown>>();

/**
 * Run `fn()` at most once per `key` until the promise settles; parallel callers await the same promise.
 */
export function withDedupe<T>(key: string, fn: () => Promise<T>): Promise<T> {
  const existing = inflight.get(key) as Promise<T> | undefined;
  if (existing) {
    return existing;
  }
  const p = fn().finally(() => {
    inflight.delete(key);
  });
  inflight.set(key, p);
  return p;
}
